/**
 * Onboarding Message Component
 * Display AI messages during onboarding flow
 */

import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { colors } from '../../theme/colors';
import { typography } from '../../theme/typography';
import { spacing } from '../../theme/spacing';

interface OnboardingMessageProps {
  message: string;
}

export default function OnboardingMessage({ message }: OnboardingMessageProps) {
  return (
    <View style={styles.container}>
      <View style={styles.bubble}>
        <Text style={styles.text}>{message}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginVertical: spacing.md,
    paddingHorizontal: spacing.md,
    alignItems: 'flex-start',
  },
  bubble: {
    maxWidth: '85%',
    padding: spacing.lg,
    borderRadius: 16,
    backgroundColor: colors.aiMessage,
    borderBottomLeftRadius: 4,
  },
  text: {
    fontSize: typography.fontSize.lg,
    color: colors.aiMessageText,
    lineHeight: typography.lineHeight.normal * typography.fontSize.lg,
  },
});
